export default {
      id: "logo-crema-usage",
      viewBox: "0 0 92 24",
      url: __webpack_public_path__ + "img/icons.c2f64a3b.svg#logo-crema",
      toString: function () {
        return this.url;
      }
    }